import React, { useEffect, useState } from 'react';

import { appendToUserObjectArray, sendBrazeEvent } from 'apps/auth/analytics/braze';
import { CommonPage } from 'apps/auth/components/common/Layout/CommonPage/CommonPage';
import RecipientList from 'apps/auth/components/common/recipientList/RecipientList';
import { SelectCountryScreenPureComponent } from 'apps/auth/components/common/search/SelectCountryScreen';
import BasePage from 'apps/auth/components/utils/BasePage';
import { BR_SEND_COUNTRY_TO_SELECTED } from 'apps/auth/constants/braze/brazeEvents';
import { BR_COUNTRY, BR_COUNTRY_CODE, BR_RECIPIENT_COUNTRIES, BR_SELECTED_DATE } from 'apps/auth/constants/braze/brazeParams';
import { AUTH_GA_ACCOUNTS, AUTH_GA_POCKET } from 'apps/auth/constants/UrlConstants';
import { toUpperCase } from 'apps/auth/helpers/utils';
import { useExtra, usePageMessages } from 'apps/auth/hooks/selectors';

const GaSendSelectCountryPage = ({ stateOptions: { isBonus }, ...props }) => {
    const { countriesTo, pocket, recipientList } = useExtra();
    const { title, countriesHeader, searchPlaceholder, searchByCountryPlaceholder, searchNoResult, recipientHeader, recipientListSubtitle, gotIt } =
        usePageMessages();

    const isShowRecipientListDefault = () => Array.isArray(recipientList) && recipientList.length > 0 && !isBonus;
    const [showRecipientList, toggleRecipientList] = useState(isShowRecipientListDefault());

    useEffect(() => {
        toggleRecipientList(isShowRecipientListDefault());
    }, [recipientList]);

    const getSendUrIPrefix = (pocketId) => `${AUTH_GA_POCKET}${pocketId}/send`;
    const getFullViewSearchBackUri = (pocketId) => `{AUTH_GA_POCKET}${pocketId}`;

    const sendBrazeEventAndAttr = (country) => {
        appendToUserObjectArray(BR_RECIPIENT_COUNTRIES, {
            [BR_COUNTRY_CODE]: toUpperCase(country?.code) || '',
            [BR_SELECTED_DATE]: new Date().toISOString(),
        });
        sendBrazeEvent(BR_SEND_COUNTRY_TO_SELECTED, { [BR_COUNTRY]: country?.id?.toString() });
    };

    return (
        <CommonPage>
            {showRecipientList && (
                <RecipientList
                    title={recipientHeader}
                    subtitle={recipientListSubtitle}
                    linkTo={`${AUTH_GA_POCKET}${pocket?.id}`}
                    pocketId={pocket?.id}
                    recipientList={recipientList}
                    toggleRecipientList={toggleRecipientList}
                    toggleSpinner={props.toggleSpinner}
                />
            )}
            {!showRecipientList && (
                <SelectCountryScreenPureComponent
                    pocketId={pocket?.id}
                    countries={countriesTo}
                    title={title}
                    gotIt={gotIt}
                    countriesHeader={countriesHeader}
                    searchPlaceholder={searchPlaceholder}
                    fullScreenSearchPlaceholder={searchByCountryPlaceholder}
                    searchNoResult={searchNoResult}
                    toggleRecipientList={toggleRecipientList}
                    sendUrIPrefix={getSendUrIPrefix(pocket?.id)}
                    fullViewSearchBackUri={getFullViewSearchBackUri(pocket?.id)}
                    linkTo={AUTH_GA_ACCOUNTS}
                    sendBrazeEvent={sendBrazeEventAndAttr}
                />
            )}
        </CommonPage>
    );
};

export default BasePage(GaSendSelectCountryPage);
